import mapSpaceItem from '@src/libs/utils/mapSpaceItem';
import getFavourites from '@src/containers/Session/selectors/getFavourites';
import getViewed from '@src/containers/Session/selectors/getViewed';
import mapServerSpace from '@src/libs/utils/mapServerSpace';
import mapRatingAndImgs from '@src/libs/utils/mapSpaceCard';

const { createSelector } = require('reselect');

const serverItems = (store) => {
	return store.SpacesListing.fetchRecentViewed.data?.entity || {};
};

const favIds = createSelector(getFavourites, (favs) => {
	return favs?.spaces.map(({ id }) => id) || [];
});

/**
 * @deprecated из-за смены интерфейса с `<Card>` на `<Space>` использовать `getViewedItems2`
 */
const getViewedItems = createSelector(serverItems, favIds, (entities, favs) => {
	return Object.keys(entities)
		.map((id) => entities[id])
		.map(mapSpaceItem(favs));
});

export const getViewedItems2 = createSelector(
	serverItems,
	favIds,
	getViewed,
	(entities, favs, viewed) => {
		return viewed.spaces
			.map(({ id: spaceId }) => entities[spaceId])
			.map(
				mapServerSpace({ favIds: favs, additional: mapRatingAndImgs }),
			);
	},
);

export default getViewedItems;
